import React from 'react';
import PropTypes from 'prop-types';
import styles from './Photo.module.scss';

const Photo = (props) => {
  return (
    <div className={styles.photo}>
      <img
        src={props.photo.pathThumbnail}
        style={{borderRadius: '4px'}}
      />
    </div>
  );
};

Photo.propTypes = {
  photo: PropTypes.object
};

export default Photo;